/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow */
/* eslint-disable func-style */
// eslint-disable-next-line arrow-parens
export const setDailyRentalPrice = weeklyRentalPrice =>
  weeklyRentalPrice ? (weeklyRentalPrice / 7) * 100 : null

export const containsRentalEquipmentTags = tag =>
  tag.includes(`assetcondition:new`) || tag.includes(`shopcondition:new`)
